import { IProduktdefinition } from "./IProduktdefinition";
import { ProduktdefinitionMatrisdata } from "./ProduktdefinitionMatrisdata";

export class ProduktdefinitionFordelningsmatrisdata {
    langddistributionMaxavvikelse: number;
    fordelningsaptering: boolean;
    fordelningstyp: string;

    constructor(model: IProduktdefinition, readonly matrisdata: ProduktdefinitionMatrisdata) {
        this.langddistributionMaxavvikelse = model.langddistributionMaxavvikelse;
        this.fordelningsaptering = model.fordelningsaptering;
        this.fordelningstyp = model.fordelningstyp;
    }

    mapToDto(model: IProduktdefinition) {
        model.langddistributionMaxavvikelse = this.langddistributionMaxavvikelse;
        model.fordelningstyp = this.fordelningstyp;
        model.fordelningsaptering = this.fordelningsaptering;
    }
}
